module.exports = __webpack_public_path__ + "static/levys-store-6ed4349219f56eb18d572d3a1315840b.jpg";